<template>
    <div>
        <el-date-picker
            type="datetimerange"
            range-separator="~"
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :format="dateFormat"
            v-model="convertedVal"
            @input="handleChange"
        />
        <span class="days">{{ unitStr }}数：{{ value.days || "无" }}</span>
    </div>
</template>
<script>
import moment from "moment"
import { getAction } from '@/utils'
export default {
    name: "DateDays",
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: true,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        isChange: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: "请选择",
        },
        value: {
            type: [Array, Object],
            default: () => [],
        },
        checks:{
            type: Array,
            default: () => ['工作日'],
        },
        unit: {
            type: String,
            default: 'day',
        },
        hasWorkTime: {
            type: Boolean,
            default: false,
        },
        workingDate: {
            type: Array,
            default: () => [
                new Date(0, 0, 0, 8, 0, 0),
                new Date(0, 0, 0, 17, 0, 0),
            ],
        },
        checkStrictly: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: "—",
        },
    },
    computed: {
        convertedVal: {
            get() {
                const { start, end } = this.value;
                return this.value ? [start, end] : this.value;
            },
            set(val) {
                return val
            }
        },
        unitStr(){
            return this.unit === 'hour' ? '小时' : '天'
        },
        dateFormat(){
            return 'yyyy-MM-dd HH:mm:ss'
        }
    },
    methods: {
        getApi() {
            const { option: { api } } = this.$attrs
            if (!api) return false
            const { calculateWorkTime } = api
            return calculateWorkTime
        },
        async handleChange([_start, _end]) {
            let _value;
            console.log(moment(_start).format("YYYY-MM-DD HH:mm:ss"), moment(_end).format("YYYY-MM-DD HH:mm:ss"))
            if (_start && _end) {
                const { workingDate: workTime, checks, hasWorkTime } = this;
                const start = moment(_start).format("YYYY-MM-DD HH:mm:ss");
                const end = moment(_end).format("YYYY-MM-DD HH:mm:ss");
                const data = {
                    hasWorkTime,
                    workTime,
                    start,
                    end,
                    hasWorkDay: false, // 包含工作日
                    hasNotWorkDay: false, // 包含非工作日
                    unit: this.unit,
                };
                if (checks.includes("工作日")) data.hasWorkDay = true;
                if (checks.includes("非工作日")) data.hasNotWorkDay = true;
                const calculateWorkTime = this.getApi()
                const [ action ] = getAction(calculateWorkTime)
                this.convertedVal = [_start, _end]
                try {
                    const res = await action(data);
                    _value = { days: res.data, start, end };
                } catch (err) {
                    _value = { days: 0, start: moment(_start).format("YYYY-MM-DD HH:mm:ss"), end: moment(_end).format("YYYY-MM-DD HH:mm:ss") };
                }
            } else {
                _value = { days: 0, start: undefined, end: undefined };
            }
            this.$emit("input", _value);
            this.$emit("change", _value);
        },
    }
}
</script>
<style lang="less" scoped>
.days {
    margin-left: 40px;
}
</style>